export function isNullish(val: unknown) {
  return ['', null, undefined].includes(val);
}
